import { StyleSheet } from 'aphrodite';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { red500 } from 'material-ui/styles/colors';

const { palette } = getMuiTheme(lightBaseTheme);

export default StyleSheet.create({
  page: {
    display: 'flex',
    paddingTop: '5rem',
    height: '100vh',
    flexDirection: 'column',
    alignItems: 'center',
    background: palette.accent2Color,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
    width: '50rem',
    '@media (max-width: 600px)': {
      width: '95%',
    },
  },
  header: {
    margin: 0,
    padding: '2rem',
    transform: 'translate(-2rem)',
    borderLeft: `${palette.primary1Color} 0.5rem solid`,
    color: palette.primary1Color,
  },
  btn: {
    margin: '2rem 0 1.5rem',
  },
  forgot: {
    alignSelf: 'flex-end',
  },
  link: {
    color: palette.accent3Color,
    textDecoration: 'none',
  },
  create: {
    display: 'inline-block',
    margin: '1.5rem 0 0',
    color: palette.accent1Color,
  },
  authError: {
    color: red500,
  },
});



// WEBPACK FOOTER //
// ./src/components/auth/auth-style.js